import script from "./SubscriptionPrice.vue?vue&type=script&lang=ts&setup=true"
export * from "./SubscriptionPrice.vue?vue&type=script&lang=ts&setup=true"

import "./SubscriptionPrice.vue?vue&type=style&index=0&id=5ec96cf4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ec96cf4"]])

export default __exports__